import React, {useEffect} from 'react';
import { useDispatch } from 'react-redux';
import {NavLink} from 'react-router-dom';
import Select from 'react-select';
import {topMenuUserIconSVG} from 'global/svgIcons/svgIcons.js'
import S from 'StyledLoggedPanel.js';
import {translation, formatMoney} from 'helpers/utilsHelper.js';
import _each from 'lodash/each';
import _find from 'lodash/find';
import useToggle from 'UseToggle.js';
import AccountModal from 'AccountModal.js';
import Account from 'Account.js';
import {toggleSessionExtensionModal} from 'authActions.js';
import ChevronIcon from 'chevron_down_dark.svg';
import ModalOpacity from 'ModalOpacity.js';
import SessionExtension from 'SessionExtension.js'; 

const LoggedPanel = ({user, logOut, balanceId, toggleBalance, isAccountOpen, isOpenSessionExtensionModal}) => {

    const dispatch = useDispatch();
    const {login, currencyCode, balance, bonusBalanceList} = user;
    const [showAccountModal, toggleAccountModal] = useToggle(isAccountOpen);

    const closeModal = () => {
        dispatch(toggleSessionExtensionModal({isOpen: false, sessionClosed: false}));
    };

    const onBalanceChange = ({value}) => {
        const balanceId = value;
        const setBonusBalance = Boolean(balanceId);

        toggleBalance(setBonusBalance, balanceId);
        localStorage.setItem('_bonus_balance_id', balanceId);
    };

    const selectedOption = () => {
        const currentBalanceId = localStorage.getItem('_bonus_balance_id') || balanceId;
        const selectedValue = _find(getBalanceList(), {value: Number(currentBalanceId)});
        return selectedValue;
    };

    const getBalanceList = () => {
        const options = [];
        const mainBalance = {
            value: 0,
            label: `${translation('account_loggedPanel_balance')}: ${formatMoney(balance)} ${currencyCode}`
        };

        options.push(mainBalance);

        _each(bonusBalanceList, ({nameKey, currency, wagerBonusId, amount}) => {
            const bonusBalance = {
                value: wagerBonusId,
                label: `${translation(nameKey)}: ${formatMoney(amount)} ${currency}`
            };
            options.push(bonusBalance);
        });

        return options;
    };

    useEffect(() => {
        const currentBalanceId = localStorage.getItem('_bonus_balance_id') || balanceId;
        const setBonusBalance = Boolean(parseInt(currentBalanceId));

        toggleBalance(setBonusBalance, currentBalanceId);
        app.service.BetSlip.betSlip.placeFromBonusBalance = Boolean(parseInt(currentBalanceId));

        // need to refactor if project use React BetSlip
        app.service.BetSlip.calculateWinning();
    }, [balanceId]);

    useEffect(() => {
        if (showAccountModal && !isAccountOpen) {
            toggleAccountModal();
        } else if (!showAccountModal && isAccountOpen) {
            toggleAccountModal();
        }

    }, [isAccountOpen]);

    // Logout user - need calculateWinning call
    useEffect(() => {
        return () => {
            // need to refactor if project use React BetSlip
            app.service.BetSlip.calculateWinning();
        }
    }, []);

    return (
        <S.LoggedPanel className="logged-panel">

            <AccountModal isOpen={showAccountModal} toggleOpen={toggleAccountModal}>
                <Account user={user} toggleBalance={toggleBalance} balanceId={balanceId} />
            </AccountModal>

            <ModalOpacity isOpen={isOpenSessionExtensionModal} titleColor="#fff" toggleOpen={()=>logOut(true)} backgroundBody="#DEDEDE" backgroundHeader="#019A44" padding="0px" width="55rem" showCloseIcon={false}>
               <SessionExtension toggleSessionExtensionModal={closeModal}></SessionExtension>
            </ModalOpacity>

 {/*
            <S.UserAccout className="user-accout">
                <div className='container'>
                    <S.UserIcon dangerouslySetInnerHTML={topMenuUserIconSVG()}></S.UserIcon>
                    <S.UserLogin className="user-login">{login}</S.UserLogin>
                    <S.UserChevron dangerouslySetInnerHTML={{__html: ChevronIcon}}></S.UserChevron> 
                </div>
                <S.QuickMenuWrapper className='user-wrapper'>
                    <S.QuickMenu>
                    */}
                {/*   <S.QuickMenuItem>
                            <S.QuickMenuLink as={NavLink}
                                         activeClassName="active"
                                         to="/payments"
                                         onClick={toggleAccountModal.bind(null, true)}>
                            {translation('topMenu_payments')}
                            </S.QuickMenuLink>

                        </S.QuickMenuItem>
                        */}
                        {/*
                        <S.QuickMenuItem>
                            <S.QuickMenuLink as={NavLink}
                                         activeClassName="active"
                                         to="/wallet"
                                         onClick={toggleAccountModal.bind(null, true)}>
                            {translation('topMenu_transactionHistory')}
                            </S.QuickMenuLink>
                        </S.QuickMenuItem>
                        */}
                        {/*  
                        <S.QuickMenuItem>
                            <S.QuickMenuLink as={NavLink}
                                             activeClassName="active"
                                             to="/bet-history"
                                             onClick={toggleAccountModal.bind(null, true)}>
                                {translation('topMenu_betHistory')}
                            </S.QuickMenuLink>
                        </S.QuickMenuItem>
                        */}
                   {/*      <S.QuickMenuItem>
                            <S.QuickMenuLink as={NavLink}
                                         activeClassName="active"
                                         to="/edit-profile"
                                         onClick={toggleAccountModal.bind(null, true)}>
                            {translation('topMenu_editProfile')}
                            </S.QuickMenuLink>
                        </S.QuickMenuItem>
                        */}
                        {/* 
                        <S.QuickMenuItem>
                            <S.QuickMenuLink as={NavLink}
                                         activeClassName="active"
                                         to="/gambling-controls"
                                         onClick={toggleAccountModal.bind(null, true)}>
                            {translation('topMenu_gamblingControls')}
                            </S.QuickMenuLink>
                        </S.QuickMenuItem>
                        */}
                        {/* 
                            <S.QuickMenuItem onClick={() => logOut(true)}>
                                    {translation('common_logout')}
                            </S.QuickMenuItem>
                        */}
                        {/*
                    </S.QuickMenu>

                </S.QuickMenuWrapper>
            </S.UserAccout>
 */}

 {/*
            <S.BalanceSelect as={Select} options={getBalanceList()} value={selectedOption()} onChange={onBalanceChange}
                             isSearchable={false} classNamePrefix="react-select" className="react-select-container"/>
*/}


        </S.LoggedPanel>
    );
};

export default React.memo(LoggedPanel);
